import React from "react";
import { Phone, MessageCircle, AlertTriangle } from "lucide-react";
import { CONTACTS, waLink, telLink } from "../lib/contact";

export default function FinalCTA() {
  return (
    <section
      id="contato"
      data-testid="final-cta-section"
      className="relative py-24 lg:py-32 bg-black overflow-hidden"
    >
      {/* Bg accents */}
      <div className="absolute inset-0 -z-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#f3bd0e]/10 blur-3xl rounded-full"></div>
      </div>
      <div className="absolute top-0 left-0 right-0 h-1.5 warning-tape"></div>
      <div className="absolute bottom-0 left-0 right-0 h-1.5 warning-tape"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-red-500/10 border border-red-500/30 rounded-sm mb-7">
          <AlertTriangle className="w-3.5 h-3.5 text-red-400" />
          <span className="text-[11px] font-bold tracking-[0.25em] uppercase text-red-300">
            Emergência? Ligue agora
          </span>
        </div>

        <h2
          className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase tracking-tighter text-white leading-[0.95]"
          data-testid="final-cta-headline"
        >
          Precisa de assistência
          <br />
          auto <span className="text-[#f3bd0e]">agora?</span>
        </h2>
        <p className="mt-6 text-white/75 text-base sm:text-lg max-w-2xl mx-auto">
          Não fique parado na rua. Nossa equipe está pronta para atender você a
          qualquer hora do dia ou da noite.
        </p>

        {/* Phone cards */}
        <div className="mt-12 grid gap-4 max-w-md mx-auto">
          {CONTACTS.phones.map((p, idx) => (
            <div
              key={p.raw}
              data-testid={`final-phone-card-${idx}`}
              className="bg-[#0A0A0A] border border-white/10 hover:border-[#f3bd0e] rounded-lg p-6 transition group"
            >
              <div className="flex items-center justify-center gap-2 text-[11px] font-bold uppercase tracking-[0.25em] text-[#f3bd0e] mb-3">
                <MessageCircle className="w-3.5 h-3.5" />
                WhatsApp / Ligação
              </div>
              <div className="font-display text-2xl sm:text-3xl text-white tracking-tight">
                {p.label}
              </div>
              <div className="mt-5 grid grid-cols-2 gap-2">
                <a
                  href={waLink(p.raw)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`final-whatsapp-${idx}`}
                  className="flex items-center justify-center gap-2 bg-[#25D366] text-white font-bold uppercase text-xs px-4 py-3 rounded-md hover:opacity-90 transition"
                >
                  <MessageCircle className="w-4 h-4" />
                  WhatsApp
                </a>
                <a
                  href={telLink(p.raw)}
                  data-testid={`final-call-${idx}`}
                  className="flex items-center justify-center gap-2 bg-[#f3bd0e] text-black font-bold uppercase text-xs px-4 py-3 rounded-md hover:bg-yellow-300 transition"
                >
                  <Phone className="w-4 h-4" />
                  Ligar
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Service tags */}
        <div className="mt-14 flex flex-wrap items-center justify-center gap-2">
          {[
            "🚨 Atendimento 24 Horas",
            "🚗 Troca de Estepe",
            "🔋 Carga de Bateria",
            "🔑 Chaveiro Automotivo",
            "🛞 Borracharia Móvel",
            "⛽ Auxílio Combustível",
            "🛡️ Anjo da Guarda",
          ].map((t) => (
            <span
              key={t}
              className="px-4 py-2 bg-black border border-white/10 rounded-sm text-xs font-bold uppercase tracking-wider text-white/80"
            >
              {t}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
